import { useHistory } from "react-router-dom";
import { GridEventListener, GridEvents } from "@mui/x-data-grid-pro";

import { buildBillingPageUrl } from "../../../utils/url";

interface BillingsTableHandlers {
  handleAdditionalRowClick: GridEventListener<GridEvents.rowClick>;
}

export const useGetBillingsTableHandlers = (): BillingsTableHandlers => {
  const history = useHistory();

  const handleAdditionalRowClick: GridEventListener<GridEvents.rowClick> = (params) => {
    const billingId = params.row.billingId;

    history.push(buildBillingPageUrl(billingId));
  };

  const billingsTableHandlers: BillingsTableHandlers = {
    handleAdditionalRowClick,
  };

  return billingsTableHandlers;
};
